import { render, staticRenderFns } from "./CPLink.vue?vue&type=template&id=536f383a&"
import script from "../scripts/CPLink.js?vue&type=script&lang=js&"
export * from "../scripts/CPLink.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports